module.exports = __webpack_public_path__ + "img/15.88e71e43.svg";